<script lang="ts" setup>
import { getImageUrl } from "@/shared/getImageUrl";
import { mdiArrowRightThin, mdiCheck } from "@mdi/js";
import { useTranslate } from "@/composables/use-translate";

const { t } = useTranslate();

type Item = {
  title: string;
  points: string[];
  to: string;
};

const items: Item[] = [
  {
    title: "Spelend leren spellen met Taalblobs",
    points: [
      "Spelling niveau " + t("groep n tm groep n", [3, 8]),
      "Meer dan 4500 woorden",
      "Gestructureerd oefenen",
    ],
    to: "contact",
  },
  {
    title: "Hoogstaande kwaliteit voor iedereen",
    points: [
      "Uitstekende didactische leerlijn",
      "Door leerspecialisten ontwikkeld",
      "Methode onafhankelijk",
    ],
    to: "contact",
  },
  {
    title: "Bepaal zelf hoe en wat er wordt geoefend",
    points: [
      "Automatisch adaptief oefenen",
      "Ook handmatig instelbaar",
      "Handelingsplan aanmaken voor zorgleerlingen",
    ],
    to: "contact",
  },
];
</script>

<template>
  <v-carousel cycle height="500" hide-delimiter-background show-arrows="hover">
    <v-carousel-item
      v-for="(item, index) in items"
      :key="index"
      :src="getImageUrl(`/img/largebanner${index + 1}.jpg`)"
      style="background-color: #b1e9f8"
      cover
      alt=""
    >
      <div
        class="fill-height text-white d-flex align-center px-6"
        style="background-color: rgba(0, 0, 0, 0.6)"
      >
        <div style="max-width: 80rem" class="mx-auto flex-grow-1">
          <div
            style="
              text-shadow:
                -1px -1px 0 #000,
                1px -1px 0 #000,
                -1px 1px 0 #000,
                1px 1px 0 #000;
            "
          >
            <h2 class="pb-6 text-h3 font-weight-bold">
              {{ item.title }}
            </h2>

            <div
              v-for="(point, i2) in item.points"
              :key="i2"
              class="d-flex align-center pb-3"
              style="font-size: 1.25rem"
            >
              <div
                class="bg-white rounded-circle mr-4 d-flex justify-center align-center"
                style="height: 2.125rem; width: 2.125rem"
              >
                <v-icon size="24">{{ mdiCheck }}</v-icon>
              </div>
              {{ point }}
            </div>
          </div>
          <v-btn
            class="mt-4"
            size="large"
            v-if="item.to"
            color="primary"
            :to="{ name: item.to }"
          >
            Lees verder
            <v-icon size="24" class="ml-2">{{ mdiArrowRightThin }}</v-icon>
          </v-btn>
        </div>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>
